import React from "react";
import {
  AiFillGithub,
  AiFillInstagram,
  AiFillLinkedin,
  AiOutlineTwitter,
  AiOutlineWhatsApp,
} from "react-icons/ai";
import me from "../assets/sumits21.jpg";

import { Context } from "../Context";
import { useContext } from "react";

const Footer = () => {
  const { darkMode } = useContext(Context);
  return (
    <footer className={`${darkMode ? "lightModeFooter" : "darkModeFooter"}`}>
      <div>
        <img src={me} alt="Sumitkumargautam" />
        <h2>Sumit Kumar Gautam</h2>
        <p>
          "Life is like riding a bicycle. To keep your balance, you must keep
          moving.”
        </p>
        <span>—Albert Einstein</span>
      </div>
      <aside>
        <h2>Get In Touch</h2>
        <article>
          <a
            href="https://www.linkedin.com/in/sumit-kumar-gautam/"
            target={"blank"}
          >
            <AiFillLinkedin />
          </a>
          <a href="https://www.instagram.com/sumit.04.10" target={"blank"}>
            <AiFillInstagram />
          </a>
          <a href="https://github.com/sumit0410" target={"blank"}>
            <AiFillGithub />
          </a>
          <a href="https://wa.me/+918418999262" target={"blank"}>
            <AiOutlineWhatsApp />
          </a>
          <a href="https://twitter.com/SumitKu37163123" target={"blank"}>
            <AiOutlineTwitter />
          </a>
        </article>
        <p>Designed with ❤ by Sumit</p>
      </aside>
      {/* <p>&copy; 2023 Sumit Kumar Gautam</p> */}
    </footer>
  );
};

export default Footer;
